import React from 'react';
import { useNavigate } from 'react-router-dom';

// Hub for the day-to-day order and PO worklists front-line staff work through.
const CARDS = [
  {
    path:        '/received-pos',
    icon:        '📦',
    title:       'Received POs & Customer Orders',
    description: 'View received purchase orders with outstanding customer order lines ready to dispatch.',
    accent:      'gold',
  },
  {
    path:        '/open-po-tracker',
    icon:        '📋',
    title:       'Open PO Worklist',
    description: 'Sales orders older than 3 days with unfulfilled items tied to open purchase orders.',
    accent:      'gold',
  },
  {
    path:        '/blocked-orders',
    icon:        '🚧',
    title:       'Problem Encountered',
    description: 'Sales orders stuck in Problem Encountered or To Call Customer — action and log notes.',
    accent:      'red',
  },
  {
    path:        '/product-margin-watch',
    icon:        '🏷️',
    title:       'Product Margin Watch',
    description: 'Active products priced below 30% gross profit (GST-adjusted cost), grouped by supplier.',
    accent:      'red',
  },
];

const FrontlineTools = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/')}>← Home</button>
        <span className="page-nav__title">Frontline Tools</span>
      </div>

      <div className="home-greeting">
        <p className="home-greeting__sub">Select a function to get started</p>
      </div>
      <div className="home-cards">
        {CARDS.map((card) => (
          <button
            key={card.path}
            className={`home-card home-card--${card.accent}`}
            onClick={() => navigate(card.path)}
          >
            <div className="home-card__icon">{card.icon}</div>
            <div className="home-card__body">
              <div className="home-card__title">{card.title}</div>
              <div className="home-card__desc">{card.description}</div>
            </div>
            <div className="home-card__arrow">→</div>
          </button>
        ))}
      </div>
    </main>
  );
};

export default FrontlineTools;
